import { toLocaleDateTime } from 'common/utils/dateUtils';
import { TextCell } from './TextCell';
import { isValid } from 'date-fns';

const getFormatedDate = (value: any) => {
  if (value === null) {
    return null;
  }

  const dateToDisplay = new Date(value);
  if (!isValid(dateToDisplay)) {
    return undefined;
  }

  return toLocaleDateTime(dateToDisplay);
};

export const DateTimeCell = ({ value, subValue }: any) => {
  return (
    <TextCell value={value ? getFormatedDate(value) : '-'} subValue={getFormatedDate(subValue)} />
  );
};
